import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

function TestsProceduresIndex() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const handleLetterClick = (letter) => {
    navigate(`/tests-procedures/${letter}`);
    window.scrollTo(0, 0);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/tests-procedures/${searchQuery.charAt(0).toUpperCase()}?search=${encodeURIComponent(searchQuery)}`);
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      {/* Hero Section - White Background */}
      <section className="py-5" style={{ backgroundColor: '#fff', color: '#333', minHeight: '400px' }}>
        <div className="container">
          <nav aria-label="breadcrumb" className="mb-3">
            <ol className="breadcrumb" style={{ backgroundColor: 'transparent', padding: 0 }}>
              <li className="breadcrumb-item"><Link to="/" style={{ color: '#0066cc' }}>Home</Link></li>
              <li className="breadcrumb-item active" style={{ color: '#666' }}>Tests & Procedures</li>
            </ol>
          </nav>

          <h1 className="display-4 mb-3" style={{ fontFamily: 'Lora, serif', fontWeight: 'bold', color: '#003d82' }}>
            Tests & Procedures
          </h1>
          <p className="lead mb-5" style={{ fontSize: '1.1rem', color: '#666' }}>
            Easy-to-understand information about medical tests and procedures
          </p>

          <div className="row mt-4">
            <div className="col-lg-6">
              <label className="mb-2" style={{ fontSize: '0.95rem', fontWeight: '600', color: '#333' }}>
                Search tests & procedures
              </label>
              <form onSubmit={handleSearch}>
                <div className="input-group input-group-lg">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ borderRadius: '8px 0 0 8px', border: '1px solid #ddd' }}
                  />
                  <button className="btn btn-primary" type="submit" style={{ borderRadius: '0 8px 8px 0', backgroundColor: '#003d82', borderColor: '#003d82' }}>
                    <i className="bi bi-search"></i>
                  </button>
                </div>
              </form>
            </div>
            <div className="col-lg-6">
              <label className="mb-2" style={{ fontSize: '0.95rem', fontWeight: '600', color: '#333' }}>
                Find tests & procedures by first letter
              </label>
              <div className="d-flex flex-wrap gap-2">
                {alphabet.map((letter) => (
                  <button
                    key={letter}
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => handleLetterClick(letter)}
                    style={{
                      width: '45px',
                      height: '45px',
                      borderRadius: '50%',
                      fontWeight: '600',
                      border: '2px solid #003d82',
                      color: '#003d82',
                      fontSize: '1rem'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#003d82';
                      e.target.style.color = '#fff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = '#003d82';
                    }}
                  >
                    {letter}
                  </button>
                ))}
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => handleLetterClick('#')}
                  style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '50%',
                    fontWeight: '600',
                    border: '2px solid #003d82',
                    color: '#003d82',
                    fontSize: '1rem'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#003d82';
                    e.target.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#003d82';
                  }}
                >
                  #
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Cards Section - White Background */}
      <section className="py-5" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <div className="row g-4 mb-5">
            {/* Symptoms browse card */}
            <div className="col-md-12 mb-4">
              <div className="card border-0 shadow-sm" style={{ borderRadius: '8px', overflow: 'hidden' }}>
                <div className="row g-0" style={{ minHeight: '300px' }}>
                  <div className="col-md-6">
                    <div className="card-body p-4" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%', minHeight: '300px' }}>
                      <div className="mb-2" style={{ fontSize: '1.75rem' }}>
                        <i className="bi bi-heart-pulse" style={{ color: '#003d82' }}></i>
                      </div>
                      <h3 className="card-title mb-2" style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>Symptoms</h3>
                      <p className="card-text text-muted mb-2" style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>
                        Browse symptoms from our articles and see related diseases and conditions.
                      </p>
                      <Link to="/symptoms" className="text-decoration-none" style={{ color: '#0066cc', fontWeight: '600', fontSize: '0.95rem' }}>
                        Browse symptoms <i className="bi bi-arrow-right ms-1"></i>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-6" style={{ display: 'flex', alignItems: 'stretch', height: '300px', overflow: 'hidden' }}>
                    <img 
                      src="/img/carousel/admin2.jpg" 
                      alt="Symptoms" 
                      className="img-fluid"
                      style={{ 
                        width: '100%', 
                        height: '300px',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block'
                      }}
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/600x400/003d82/ffffff?text=Symptoms';
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Diseases & Conditions Card */}
            <div className="col-md-6">
              <div className="card h-100 border-0 shadow-sm" style={{ borderRadius: '8px' }}>
                <div className="card-body text-center p-4">
                  <div className="mb-3" style={{ fontSize: '3rem' }}>
                    <i className="bi bi-heart-pulse" style={{ color: '#003d82' }}></i>
                  </div>
                  <h3 className="card-title mb-3" style={{ fontWeight: 'bold' }}>Diseases & Conditions</h3>
                  <p className="card-text text-muted mb-3">
                    Learn about diseases, conditions, and health topics.
                  </p>
                  <Link to="/diseases" className="text-decoration-none" style={{ color: '#0066cc', fontWeight: '600' }}>
                    Browse diseases <i className="bi bi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* Connect to Support Groups Card */}
            <div className="col-md-6">
              <div className="card h-100 border-0 shadow-sm" style={{ borderRadius: '8px' }}>
                <div className="card-body text-center p-4">
                  <div className="mb-3" style={{ fontSize: '3rem' }}>
                    <i className="bi bi-people" style={{ color: '#003d82' }}></i>
                  </div>
                  <h3 className="card-title mb-3" style={{ fontWeight: 'bold' }}>Connect to support groups</h3>
                  <p className="card-text text-muted mb-3">
                    Share your experiences and find support in our online communities.
                  </p>
                  <Link to="/contact" className="text-decoration-none" style={{ color: '#0066cc', fontWeight: '600' }}>
                    Find a support group <i className="bi bi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Featured Section - Dark Background Banner */}
          <div className="row align-items-center mb-5" style={{ backgroundColor: '#003d82', borderRadius: '12px', padding: '3rem 2rem', margin: '0' }}>
            <div className="col-lg-6">
              <h2 className="mb-3" style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff' }}>
                Understanding your tests and procedures
              </h2>
              <p className="lead mb-3" style={{ fontSize: '1.1rem', color: '#fff' }}>
                Tema General Hospital provides clear, easy-to-understand information about medical tests and procedures to help you prepare and understand what to expect.
              </p>
              <Link to="/about-us/overview" className="text-decoration-none" style={{ color: '#fff', fontWeight: '600', fontSize: '1rem' }}>
                Learn about TGH <i className="bi bi-arrow-right ms-1"></i>
              </Link>
            </div>
            <div className="col-lg-6">
              <img 
                src="/img/carousel/admin2.jpg" 
                alt="TGH Healthcare Professional" 
                className="img-fluid rounded"
                style={{ maxHeight: '400px', objectFit: 'cover', width: '100%' }}
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/600x400/003d82/ffffff?text=TGH+Healthcare';
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TestsProceduresIndex;
